import { motion } from "framer-motion";

interface LogoProps {
  size?: "sm" | "md" | "lg" | "xl";
  animated?: boolean;
}

const sizeClasses = {
  sm: "h-6",
  md: "h-8",
  lg: "h-12",
  xl: "h-16",
};

export function Logo({ size = "md", animated = true }: LogoProps) {
  const Component = animated ? motion.div : "div";

  return (
    <Component
      className="flex items-center gap-2"
      initial={animated ? { opacity: 0, y: -10 } : undefined}
      animate={animated ? { opacity: 1, y: 0 } : undefined}
      transition={animated ? { duration: 0.5 } : undefined}
    >
      <img src="/logo.png" alt="Venture Hills" className={`${sizeClasses[size]} w-auto`} />
    </Component>
  );
}
